import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HistorialAccion, Lista_Historial_Visitas, QR_Detalle_Dispositivo, QR_Detalle_Visita, QR_Detalle_Visita_Pais, QR_Detalle_Visita_Total, QR_List, QR_registro, Reporte_Paises, Reporte_x_Ciudad, Reporte_x_pais, Reporte_x_pais_Grafico, Result_RegistroQR, Result_Reporte } from '../models/QR';
import { environment } from '../../environments/environment';
import { Observable, catchError, firstValueFrom, map, throwError } from 'rxjs';
import { id } from '@swimlane/ngx-charts';
import { Result, user_autentica_bd, users } from '../models/Login';
import { User_Update, Usuario_List } from '../models/Usuario';


@Injectable({
  providedIn: 'root'
})
export class QrService {


  constructor(private http: HttpClient) {
  }

  // COMENTADO: API externa ya no disponible - usar Loguin_User()
  // public LoginUser(user: Login) {
  //   return this.http.post<Login_Estatus>(
  //     `${environment.apiLogin}/api/login`, user)
  //     .pipe(map(data => {
  //       return data;
  //     }))
  // }

 
    public  RegistrarUsuario(user: users) {
       return    this.http.post<Result>(
        `${environment.apiUrl}/Users/Registrar_Users`, user)
        .pipe(map(data => {
          return data;
        }))
    }
  
    public  Actualizar_Usuario(user: User_Update) {
      return    this.http.post<Result>(
       `${environment.apiUrl}/Users/Actualiza_User`, user)
       .pipe(map(data => {
         return data;
       }))
   }
 
   public  Loguin_User(user: user_autentica_bd) {
    return    this.http.post<users>(
     `${environment.apiUrl}/Users/Loguin_User`, user)
     .pipe(map(data => {
       return data;
     }))
 }


 


  public GuardarURL(accion: number, entidad: QR_registro): Observable<any> {
    return this.http.post<Result_RegistroQR>(
      `${environment.apiUrl}/QR/Registra_url?accion=${accion}`, entidad)
      .pipe(map(data => {
        return data;
      }))
  }
/*
  public ListaURL_Creadas(id_user: number) {
    return this.http.get<QR_List[]>(`${environment.apiUrl}/QR/Lista_URLS?id_usuario=${id_user}`)
      .pipe(map(data => {
        return data;
      }))
  }*/
     
      public  async ListaURL_Creadas(id_user: number,filtro: string): Promise<QR_List[]> {
        return firstValueFrom(this.http.get<QR_List[]>(`${environment.apiUrl}/QR/Lista_URLS?id_usuario=${id_user}&filtro=${filtro}`)
          .pipe(map(data => {
            return data;
          }))
        );
      }
      

  public async List_Cantidad_Visitas(id_qr: number) {
    return await this.http.get<QR_Detalle_Visita[]>(`${environment.apiUrl}/QR/Lista_Detalle_Visitas_x_id?id_qr=${id_qr}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public MuestraCantidadVisitasxID(id_qr: number) {
    return this.http.get<QR_Detalle_Visita_Pais[]>(`${environment.apiUrl}/QR/Lista_Visitas_x_id?id_qr=${id_qr}`)
      .pipe(map(data => {
        return data;
      }))
  }
  public MuestraCantidadVisitasxID_Fechas(id_qr: number,fechaInicio:string,fechaFin:string) {
    return this.http.get<QR_Detalle_Visita_Pais[]>(`${environment.apiUrl}/QR/Lista_Visitas_x_id_Fechas?id_qr=${id_qr}&FechaInicio=${fechaInicio}&FechaFin=${fechaFin}`)
      .pipe(map(data => {
        return data;
      }))
  }





  public MuestraCantidadVisitasxPaisID(id_qr: number) {
    return this.http.get<QR_Detalle_Visita_Pais[]>(`${environment.apiUrl}/QR/Lista_Visitas_xPais_id?id_qr=${id_qr}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public MuestraCantidadVisitasxPaisID_Fechas(id_qr: number,fechaInicio:string, FechaFin: string) {
    return this.http.get<QR_Detalle_Visita_Pais[]>(`${environment.apiUrl}/QR/Lista_Visitas_xPais_id_Fechas?id_qr=${id_qr}&FechaInicio=${fechaInicio}&FechaFin=${FechaFin}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public MuestraCantidadVisitasxDispositivoID(id_qr: number) {
    return this.http.get<QR_Detalle_Dispositivo[]>(`${environment.apiUrl}/QR/Lista_Visualizacion_x_Dispositivo?id_qr=${id_qr}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public MuestraCantidadVisitasxDispositivoID_Fechas(id_qr: number, fechaInicio:string, FechaFin: string) {
    return this.http.get<QR_Detalle_Dispositivo[]>(`${environment.apiUrl}/QR/Lista_Visualizacion_x_Dispositivo_Fechas?id_qr=${id_qr}&FechaInicio=${fechaInicio}&FechaFin=${FechaFin}`)
      .pipe(map(data => {
        return data;
      }))
  }


  public async List_Detalle_Reporte(id_qr: number) {
    return await this.http.get<QR_Detalle_Visita[]>(`${environment.apiUrl}/QR/Lista_Detalle_Visitas_x_id?id_qr=${id_qr}`)
      .pipe(map(data => {
        return data;
      }))
  }


  public Lista_Reporte(id_qr: number, tipo_reporte: number) {
    return this.http.get<Lista_Historial_Visitas[]>(`${environment.apiUrl}/QR/Lista_Reporte?tiporeporte=${tipo_reporte}&id=${id_qr}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public Lista_Reporte_Fechas(id_qr: number, tipo_reporte: number,fechaInicio:string, FechaFin: string) {
    return this.http.get<Lista_Historial_Visitas[]>(`${environment.apiUrl}/QR/Lista_Reporte_Fechas?tiporeporte=${tipo_reporte}&id=${id_qr}&FechaInicio=${fechaInicio}&FechaFin=${FechaFin}`)
      .pipe(map(data => {
        return data;
      }))
  }


  public Lista_Reporte_x_Pais(pais:string, id:number) {
    return this.http.get<Reporte_x_pais[]>(`${environment.apiUrl}/QR/Lista_Detalle_Reporte_x_Pais?pais=${pais}&id=${id}`)
      .pipe(map(data => {
        return data;
      }))
  }


  public Lista_Reporte_x_Provincia(provincia:string, id:number) {
    return this.http.get<Reporte_x_pais[]>(`${environment.apiUrl}/QR/Lista_Detalle_Reporte_x_Provincia?provincia=${provincia}&id=${id}`)
      .pipe(map(data => {
        return data;
      }))
  }


  public Lista_Reporte_x_Provincia_Fecha(provincia:string, id:number,fechaInicio:string, FechaFin: string) {
    return this.http.get<Reporte_x_pais[]>(`${environment.apiUrl}/QR/Lista_Detalle_Reporte_x_Provincia_Fecha?provincia=${provincia}&id=${id}&FechaInicio=${fechaInicio}&FechaFin=${FechaFin}`)
      .pipe(map(data => {
        return data;
      }))
  }
  
  public async Lista_Reporte_x_Pais_combo( id:number): Promise<Reporte_x_pais[]> {
    return firstValueFrom(this.http.get<Reporte_x_pais[]>(`${environment.apiUrl}/QR/Lista_Detalle_Reporte_x_Pais_final?id=${id}`)
    .pipe(map(data => {
      return data;
    }))
  );
    /*return this.http.get<Reporte_x_pais[]>(`${environment.apiUrl}/QR/Lista_Detalle_Reporte_x_Pais_final?id=${id}`)
      .pipe(map(data => {
        return data;
      }))*/
  }

  public async Lista_Reporte_x_Pais_combo_Fechas( id:number,fechaInicio:string, FechaFin: string): Promise<Reporte_x_pais[]> {
    return firstValueFrom(this.http.get<Reporte_x_pais[]>(`${environment.apiUrl}/QR/Lista_Detalle_Reporte_x_Pais_final_Fechas?id=${id}&FechaInicio=${fechaInicio}&FechaFin=${FechaFin}`)
    .pipe(map(data => {
      return data;
    }))
  );
  }

  public Lista_Cantidad_Visitas_x_Pais() {
    return this.http.get<Reporte_Paises[]>(`${environment.apiUrl}/QR/Lista_Reporte_Menu_Principal`)
      .pipe(map(data => {
        return data;
      }))
  }

  
  public Lista_Reporte_x_Pais_Grafico(pais:string, id:number) {
    return this.http.get<Reporte_x_pais_Grafico[]>(`${environment.apiUrl}/QR/Lista_Cantidad_Visitas_Pais_Grafico?pais=${pais}&id=${id}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public Lista_Reporte_x_Ciudad_Grafico(pais:string, id:number) {
    return this.http.get<Reporte_x_Ciudad[]>(`${environment.apiUrl}/QR/Lista_Cantidad_Visitas_Ciudad_Grafico?ciudad=${pais}&id=${id}`)
      .pipe(map(data => {
        return data;
      }))
  }
  
  public Lista_Reporte_x_Ciudad_Grafico_Fecha(pais:string, id:number, fechaInicio:string, FechaFin: string) {
    return this.http.get<Reporte_x_Ciudad[]>(`${environment.apiUrl}/QR/Lista_Cantidad_Visitas_Ciudad_Grafico_Fecha?ciudad=${pais}&id=${id}&FechaInicio=${fechaInicio}&FechaFin=${FechaFin}`)
      .pipe(map(data => {
        return data;
      }))
  }
  
  

  public Lista_Usuarios(filtro:string){
    return this.http.get<Usuario_List[]>(`${environment.apiUrl}/Users/Lista_Usuarios?usuario=${filtro}`)
      .pipe(map(data => {
        return data;
      }))
  }

  public Lista_Historial_Acciones(){
    return this.http.get<HistorialAccion[]>(`${environment.apiUrl}/QR/Lista_Historial_Acciones`)
      .pipe(map(data => {
        return data;
      }))
  }

//-----------------------REPORTE EXCEL ---------------------------------------------------
public Reporte_Excel_Service(  id_QR:number,fechaInicio:string, FechaFin: string) {
  return this.http.get<Result_Reporte>(`${environment.apiUrl}/QR/Generar_Reporte_Excel?&id_qr=${id_QR}&fechaInicio=${fechaInicio}&fechaFin=${FechaFin}`)
    .pipe(map(data => {
      return data;
    }))
}
  


  


}
